<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <div class="text-h5 text-center mb-8 font-weight-medium">Support</div>
        <a href="http://www.bugsnag.com/"
          ><img
            class="mx-auto mb-4"
            style="max-width: 100%"
            src="https://images.typeform.com/images/QKuaAssrFCq7/image/default-firstframe.png"
        /></a>
      </v-sheet>
    </v-row>
  </v-container>
</template>
